import React, { FunctionComponent } from 'react'
import { useTimeout } from 'react-use'

export const Spinner: FunctionComponent = () => {
  const [isReady] = useTimeout(500)

  return isReady() ? (
    <div
      style={{
        position: 'absolute',
        left: '0',
        right: '0',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={require('~/assets/loader.svg')}
        width={25}
        height={25}
        style={{ animation: 'spin 1s infinite linear' }}
        alt="loading icon"
      />
    </div>
  ) : null
}
